import React from 'react';
import { Link } from 'react-router-dom';
import { company, stats, whyUs, team } from '../data/companyData';
import './AboutPage.css';

export default function AboutPage() {
  return (
    <main className="about-page">

      {/* Page Header */}
      <section className="page-header">
        <div className="container page-header__inner">
          <span className="tag">About Us</span>
          <h1 className="page-header__title">
            A Decade of<br />
            <span style={{ color: 'var(--gold)' }}>Trusted Excellence</span>
          </h1>
          <p className="page-header__sub">
            Since {company.established}, {company.address}
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="section">
        <div className="container about-mission">
          <div className="about-mission__text">
            <span className="tag">Our Mission</span>
            <h2 className="section-title">Who We Are</h2>
            <div className="divider" />
            <p style={{ color: 'var(--mid)', fontSize: 16, lineHeight: 1.8, fontWeight: 300, marginBottom: 16 }}>
              {company.description}
            </p>
            <p style={{ color: 'var(--mid)', fontSize: 16, lineHeight: 1.8, fontWeight: 300 }}>
              Our team brings together certified engineers, qualified technicians, and seasoned project managers, all committed to delivering operations and maintenance services that exceed contractual obligations and client expectations.
            </p>
          </div>
          <div className="about-mission__stats">
            {stats.map((stat, i) => (
              <div key={i} className="about-stat-card">
                <div className="about-stat-card__value">{stat.value}</div>
                <div className="about-stat-card__label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Us */}
      <section className="section section--cream">
        <div className="container">
          <div className="about-why__header">
            <span className="tag">Why Choose Us</span>
            <h2 className="section-title">Our Commitments</h2>
          </div>
          <div className="about-why__grid">
            {whyUs.map((item, i) => (
              <div key={i} className="why-card">
                <div className="why-card__num">{String(i + 1).padStart(2, '0')}</div>
                <h3 className="why-card__title">{item.title}</h3>
                <p className="why-card__text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <span className="tag">Our Team</span>
            <h2 className="section-title">Qualified Personnel</h2>
            <p className="section-subtitle" style={{ margin: '16px auto 0' }}>
              All staff are vetted, hold relevant certifications, and are available on-demand
              including outside standard working hours at no additional cost.
            </p>
          </div>
          <div className="about-team-grid">
            {team.map((t, i) => (
              <div key={i} className="team-card">
                <div className="team-card__avatar">
                  {t.role.split(' ').map(w => w[0]).join('').slice(0, 2)}
                </div>
                <h4 className="team-card__role">{t.role}</h4>
                <p className="team-card__desc">{t.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Standards */}
      <section className="section section--pearl">
        <div className="container about-standards">
          <div className="about-standards__text">
            <span className="tag">Standards & Compliance</span>
            <h2 className="section-title">Built on<br />Best Practices</h2>
            <div className="divider" />
            <ul className="about-standards__list">
              {[
                'NFPA 780 Lightning Protection compliance',
                'Quarterly progress reporting to facility managers',
                'Daily, weekly, monthly & annual maintenance schedules',
                '24/7 emergency response — no additional charge',
                'All works approved by client before execution',
                'Fully qualified & insured workforce',
              ].map(item => (
                <li key={item}>
                  <span className="about-standards__check">✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="about-standards__cta">
            <div className="about-standards__cta-box">
              <h3>Ready to Work With Us?</h3>
              <p>Contact our team today to discuss your facility management requirements.</p>
              <Link to="/contact" className="btn btn-primary" style={{ marginTop: 24 }}>
                Get in Touch
              </Link>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}
